jQuery('.brand-block-controll a').on('click',function(event) {
    var image = jQuery(this).parents('.horizontal-cards-content').siblings('.horizontal-cards-image'),
    readmeMoreText =  jQuery(this).parents('.horizontal-cards-content').find('.read-more-text'),
    blockControl = jQuery(this).parent();
    if (readmeMoreText.hasClass('read-more-text')) {
    event.preventDefault();
    image.slideToggle('slow');
    blockControl.slideToggle('slow');
    readmeMoreText.slideToggle('slow',function(){readmeMoreText.find('svg.close-button').fadeIn('slow');});
     };
    });
jQuery('.read-more-text>svg.close-button').on('click',function(event) {
    event.preventDefault();
    jQuery(this).hide();
    jQuery(this).parents('.horizontal-cards-content-inner').siblings('.brand-block-controll').find('a').click();
});